// Chat channels. 'say' is heard nearby, 'zone' by the whole zone, 'faction' by your whole faction everywhere,
// 'whisper' by one person, 'party' by your party, 'alliance' by every party in your alliance.
// Guild is reserved and answered with "not yet" until guilds exist.
export const CHANNELS = ['say', 'zone', 'faction', 'whisper', 'party', 'alliance', 'guild', 'system'] as const;
export type Channel = typeof CHANNELS[number];
export const SENDABLE: Channel[] = ['say', 'zone', 'faction', 'whisper', 'party', 'alliance', 'guild'];
export const NOT_YET: Channel[] = ['guild'];

/** Slash commands typed in the chat box. */
export function parseChat(line: string): { ch: Channel; to?: string; text: string } | null {
  const t = line.trim();
  if (!t) return null;
  if (!t.startsWith('/')) return { ch: 'say', text: t };
  const [cmd, ...rest] = t.split(' ');
  const c = cmd.slice(1).toLowerCase();
  const map: Record<string, Channel> = { s: 'say', say: 'say', z: 'zone', zone: 'zone', f: 'faction', faction: 'faction', r: 'faction', realm: 'faction', p: 'party', party: 'party', a: 'alliance', alliance: 'alliance', ra: 'alliance', raid: 'alliance', g: 'guild', guild: 'guild' };
  if (c === 'w' || c === 'whisper' || c === 'tell') { const [to, ...msg] = rest; return to ? { ch: 'whisper', to, text: msg.join(' ') } : null; }
  return map[c] ? { ch: map[c], text: rest.join(' ') } : null;
}

/** Strip control characters and trim to the limit. */
export function cleanText(s: unknown, max: number): string {
  if (typeof s !== 'string') return '';
  return s.replace(/[\u0000-\u001f\u007f\u2028\u2029]/g, '').trim().slice(0, max);
}
